document.addEventListener( 'click', ( e ) => {
  const isFacetPage = e.target.classList.contains( 'facetwp-page' );
  const isPageNumber = e.target.classList.contains( 'page-numbers' );
  const isFacetRadioInsideCategory = e.target.classList.contains( 'facetwp-radio' ) &&
    e.target.closest( '.facetwp-facet-integration_category' );

  if ( isFacetPage || isPageNumber || isFacetRadioInsideCategory ) {
    const adminBar = document.getElementById( 'wpadminbar' );
    const header = document.querySelector( 'header' );
    const headerHeight = header ? header.offsetHeight : 0;
    const totalHeaderHeight = headerHeight + ( adminBar ? adminBar.offsetHeight : 0 );

    let currentElement = e.target;
    while ( currentElement && currentElement.tagName !== 'SECTION' ) {
      currentElement = currentElement.parentElement;
    }

    if ( currentElement ) {
      const targetSectionTop = currentElement.offsetTop;
      window.scrollTo( {
        top: targetSectionTop - totalHeaderHeight,
        behavior: 'smooth'
      } );
    }
  }
} );
